"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_localize_redux_1 = require("react-localize-redux");
const credentialActionInfoBlockTranslations_json_1 = __importDefault(require("../credentialActionInfoBlock/credentialActionInfoBlocktranslations/credentialActionInfoBlockTranslations.json"));
require("./imsJsonEmbedModal.scss");
const react_syntax_highlighter_1 = __importDefault(require("react-syntax-highlighter"));
const hljs_1 = require("react-syntax-highlighter/dist/esm/styles/hljs");
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const react_json_view_ts_1 = __importDefault(require("react-json-view-ts"));
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
const switch_badge_icon_svg_1 = __importDefault(require("../../../assets/images/icons/switch-badge-icon.svg"));
const switch_certificate_icon_svg_1 = __importDefault(require("../../../assets/images/icons/switch-certificate-icon.svg"));
const close_icon_gray_svg_1 = __importDefault(require("../../../assets/images/icons/close-icon-gray.svg"));
const ElementBaseConfig_1 = require("../../../config/ElementBaseConfig");
const BaseSwitch_1 = __importDefault(require("../../../elementKit/baseSwitch/BaseSwitch"));
const copy_icon_svg_1 = __importDefault(require("../../../assets/images/icons/copy-icon.svg"));
function ImsJsonEmbedModal(props) {
    var _a, _b;
    if (props.type === "json" && !props.jsonOptions) {
        throw new Error("Json options are required for json type");
    }
    if (props.type === "embed" && !props.embedOptions) {
        throw new Error("Embed options are required for embed type");
    }
    const [copyButtonWidth, setCopyButtonWidth] = react_1.default.useState(0);
    const [activeEmbed, setActiveEmbed] = react_1.default.useState("certificate");
    const bottomActionsRef = react_1.default.useRef(null);
    props.addTranslation(credentialActionInfoBlockTranslations_json_1.default);
    const copyToCLipboard = (jsonToCopy) => {
        let content = JSON.stringify(jsonToCopy);
        const el = document.createElement("textarea");
        el.value = content;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        el.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(el);
    };
    function handleCopyButtonWidth() {
        if (bottomActionsRef.current) {
            const width = bottomActionsRef.current.clientWidth;
            setCopyButtonWidth(width);
        }
    }
    (0, react_1.useEffect)(() => {
        if (props.isJsonEmbedModalOpen) {
            handleCopyButtonWidth();
        }
    }, [props.isJsonEmbedModalOpen, props.isMobile]);
    function getEmbedLink() {
        var _a, _b, _c, _d;
        if (((_a = props.embedOptions) === null || _a === void 0 ? void 0 : _a.certificateEmbedLink) &&
            ((_b = props.embedOptions) === null || _b === void 0 ? void 0 : _b.badgeEmbedLink)) {
            return activeEmbed === "certificate"
                ? props.embedOptions.certificateEmbedLink
                : props.embedOptions.badgeEmbedLink;
        }
        return (((_c = props.embedOptions) === null || _c === void 0 ? void 0 : _c.certificateEmbedLink) ||
            ((_d = props.embedOptions) === null || _d === void 0 ? void 0 : _d.badgeEmbedLink));
    }
    return props ? (react_1.default.createElement(Modal_1.default, { show: props.isJsonEmbedModalOpen, onHide: props.hideModal, size: "lg" },
        react_1.default.createElement("div", { className: "flex-column main-modal ai-fs" },
            react_1.default.createElement("div", { className: "flex-row head jc-sb ai-c" },
                react_1.default.createElement("span", { className: "s5 boldish" }, props
                    .translate(props.type === "embed" ? "embedCredential" : "modalHeader")
                    .toString()),
                react_1.default.createElement("img", { alt: "Verified Close Icon", src: close_icon_gray_svg_1.default, onClick: props.hideModal })),
            react_1.default.createElement("span", { className: "s6" }, props
                .translate(props.type === "embed" ? "embedModalDesc" : "modalDesc")
                .toString()),
            props.type === "embed" &&
                ((_a = props.embedOptions) === null || _a === void 0 ? void 0 : _a.badgeEmbedLink) &&
                props.embedOptions.certificateEmbedLink && (react_1.default.createElement(BaseSwitch_1.default, { switchBackgroundColor: "#36476F", primaryColor: "#FFF", fullSizeOnWeb: true, activeLabelColor: "#000E27", activeIconColor: "#000E27", inactiveLabelColor: "#FFF", isMobile: props.isMobile, options: [
                    {
                        icon: switch_certificate_icon_svg_1.default,
                        text: props.translate("certificate").toString(),
                        value: "certificate",
                    },
                    {
                        icon: switch_badge_icon_svg_1.default,
                        text: props.translate("badge").toString(),
                        value: "badge",
                    },
                ], value: activeEmbed, setValue: (value) => setActiveEmbed(value) })),
            props.type === "json" ? (react_1.default.createElement(react_json_view_ts_1.default, { src: (_b = props.jsonOptions) === null || _b === void 0 ? void 0 : _b.imsJson, theme: "ocean", displayDataTypes: false, displayObjectSize: false })) : (react_1.default.createElement(react_syntax_highlighter_1.default, { language: "html", style: hljs_1.anOldHope, wrapLines: true, wrapLongLines: true, customStyle: {
                    width: "100%",
                    height: "fit-content",
                } }, getEmbedLink())),
            react_1.default.createElement("div", { className: "bottom jc-sb", ref: bottomActionsRef }, props.type === "json" ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { className: "member-text", target: "_blank", href: (0, ElementBaseConfig_1.getElementkitConfig)().jsonOpenBadgesRedirectLink, rel: "nofollow noopener noreferrer" }, props.translate("openBadgesCompliant").toString()),
                react_1.default.createElement("div", { className: "specification-copy-row" },
                    react_1.default.createElement("a", { className: "s6", target: "_blank", href: (0, ElementBaseConfig_1.getElementkitConfig)().jsonSpecificationRedirectLink, rel: "nofollow noopener noreferrer" },
                        react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", className: "specification-button", loading: false, width: props.isMobile ? undefined : 210, height: 39, primaryColor: "#000e27" },
                            react_1.default.createElement("span", null, props.translate("viewSpecification").toString()))),
                    react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", height: 39, width: props.isMobile ? undefined : 210, loading: false, className: "copy-button", onClickAction: () => {
                            copyToCLipboard(props.jsonOptions.imsJson);
                        } },
                        react_1.default.createElement("span", null,
                            " ",
                            props.translate("copyToClipboard").toString()))))) : (react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", className: "specification-button", loading: false, width: !props.isMobile ? 210 : copyButtonWidth, height: 39, onClickAction: () => {
                    props.embedOptions.copyEmbedLink(getEmbedLink(), activeEmbed === "badge");
                }, primaryColor: "#000e27" },
                react_1.default.createElement("div", { className: "flex-row ai-c" },
                    react_1.default.createElement("img", { src: copy_icon_svg_1.default, alt: "Copy Icon", height: 15, width: 15, style: {
                            marginRight: "10px",
                        } }),
                    react_1.default.createElement("span", null, props.translate("copyCode").toString())))))))) : null;
}
exports.default = (0, react_localize_redux_1.withLocalize)(ImsJsonEmbedModal);
